"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "20", height: "26", viewBox: "0 0 20 26", className: "Icon export-text", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#CACACA", d: "M0 0v26h20V6.999L13 0z" }),
            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h11v7h7v17H1z" }),
            _react2.default.createElement("path", { fill: "#FFF", d: "M13 1.417l5.581 5.582H13z" }),
            _react2.default.createElement(
                "g",
                { fill: "#929292" },
                _react2.default.createElement("path", { d: "M4 12h12v1H4zM4 14h12v1H4zM4 16h12v1H4zM4 18h12v1H4z" })
            )
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/export-text.js
// module id = 1803
// module chunks = 0